import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCartTitle } from 'common/helpers/miscHelpers';
import { hideSideCart } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const Title = () => {
  const { t } = useLocalization();
  const dispatch = useDispatch();
  const buttonRef = useRef();

  const handleClick = () => {
    dispatch(hideSideCart());
  };

  const settings = useSelector((state) => state.setting.data);

  return (
    <>
      <div className="c7-side-cart__header">
        <h1 id="c7-side-cart__header__title" tabIndex="-1" className="c7-h1">
          {getCartTitle(settings, t)}
        </h1>
        <button
          type="button"
          onClick={handleClick}
          ref={buttonRef}
          id="c7-side-cart__header__close"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke="#000000"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          <span className="c7-sr-only">
            {t('general.accessibility.closeCart', {
              cartTitle: getCartTitle(settings, t)
            })}
          </span>
        </button>
      </div>
    </>
  );
};

export default Title;
